import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import theme from '../../../theme/MyEirTheme';

/*
Svg Icons already defined are:
    1.BillsIcon
    2.ServicesIcon
    3.HomeIcon
    4.HomesIcon
    5.OffersIcon
    6.HelpIcon
    7.DownloadIcon
    8.PaymentCardIcon
    9.UsageIcon
   10.PlusIcon
*/

/*
  Pass fill and stroke values through props to respective path as required in each SvgIcon components.

  If there is only one path for svg icon, then props will be fill1 & stroke1.
  If there is two paths for svg icon ,then for the first path props will be fill1 & stroke1 and for second path it will be fill2 & stroke2.
  and so on.

  To change the size of the svg icon use fontSize attribute inside the component where the icon is called.
*/

/**
 * @name BillsIcon - bills icon
 * @param {String} stroke1 - color for icon outline - default "#892BA0"
 * @param {String} fill1 - color to fill icon/icon background color -default "#892BA0"
 * @param {String} stroke1opacity - to change border opacity of icon - default "1"
 * @param {Boolean} fill1opacity - to change background opacity  of icon- default "1"
 * @param {Boolean} stroke1width - to change border width of icon - default "1.75"
 * @param {String} stroke2 - color for icon outline - default "white"
 * @param {String} fill2 - color to fill icon/icon background color -default  "transparent"
 * @param {String} stroke2opacity - to change border opacity of icon - default "1"
 * @param {Boolean} fill2opacity - to change background opacity  of icon- default "1"
 * @param {Boolean} stroke2width - to change border width of icon - default "1.75"
 * @returns {<BillsIcon>} - returns BillsIcon as a jsx component
 */

function BillsIcon(props) {
    return (
        <SvgIcon {...props}>
            <path
                d='M8.20037 7.3H15.4004M8.20037 10.9H15.4004M8.20037 14.5H11.8004M6.40009 2.5H17.2003C18.5258 2.5 19.6003 3.57454 19.6003 4.90005L19.6 19.3C19.6 20.6255 18.5255 21.7 17.2 21.7L6.39999 21.6999C5.0745 21.6999 3.99999 20.6254 4 19.2999L4.00009 4.89999C4.0001 3.57451 5.07462 2.5 6.40009 2.5Z'
                fill='none'
                stroke={props.stroke1 ? props.stroke1 : theme.palette.primary.heather}
                strokeOpacity={props.stroke1opacity ? props.stroke1opacity : '1'}
                fillOpacity={props.fill1opacity ? props.fill1opacity : '1'}
                strokeWidth={props.stroke1width ? props.stroke1width : '1.75'}
                stroke-linecap='round'
                stroke-linejoin='round'
            />
        </SvgIcon>
    );
}

/**
 * @name ServicesIcon - Services icon
 * @param {String} stroke1 - color for icon outline - default "white"
 * @param {String} fill1 - color to fill icon/icon background color - default "transparent"
 * @param {String} stroke1opacity - to change border opacity of icon - default "0.6"
 * @param {Boolean} fill1opacity - to change background opacity  of icon- default "1"
 * @param {Boolean} stroke1width - to change border width of icon - default "1.75"
 * @returns {<ServicesIcon>} - returns ServicesIcon as a jsx component
 */

function ServicesIcon(props) {
    return (
        <SvgIcon {...props}>
            <path
                d='M18.9 9.80031C18.9 10.1603 18.61 10.4503 18.25 10.4503C17.89 10.4503 17.6 10.1603 17.6 9.80031C17.6 9.44031 17.89 9.15031 18.25 9.15031C18.61 9.15031 18.9 9.44031 18.9 9.80031ZM20.67 8.43031C20.8 8.34031 20.83 8.17031 20.74 8.05031C20.17 7.21031 19.22 6.70031 18.21 6.70031C17.2 6.70031 16.31 7.17031 15.73 7.97031C15.64 8.09031 15.67 8.27031 15.79 8.36031C15.91 8.45031 16.09 8.42031 16.18 8.30031C16.65 7.65031 17.41 7.26031 18.21 7.26031C19.01 7.26031 19.81 7.67031 20.28 8.36031C20.33 8.44031 20.42 8.48031 20.51 8.48031C20.56 8.48031 20.62 8.46031 20.67 8.43031ZM21.76 7.18031C21.88 7.08031 21.9 6.91031 21.8 6.79031C20.92 5.69031 19.62 5.05031 18.21 5.05031C16.8 5.05031 15.55 5.66031 14.67 6.72031C14.57 6.84031 14.59 7.01031 14.71 7.11031C14.83 7.21031 15 7.19031 15.1 7.07031C15.87 6.14031 17 5.60031 18.21 5.60031C19.42 5.60031 20.6 6.16031 21.37 7.13031C21.42 7.20031 21.51 7.23031 21.59 7.23031C21.65 7.23031 21.71 7.21031 21.76 7.17031V7.18031ZM22.92 5.84031C23.03 5.74031 23.05 5.56031 22.94 5.45031C21.74 4.10031 20.02 3.32031 18.21 3.32031C16.4 3.32031 14.73 4.07031 13.54 5.39031C13.44 5.50031 13.45 5.68031 13.56 5.78031C13.67 5.88031 13.85 5.87031 13.95 5.76031C15.04 4.56031 16.59 3.87031 18.21 3.87031C19.83 3.87031 21.43 4.58031 22.52 5.81031C22.57 5.87031 22.65 5.90031 22.73 5.90031C22.8 5.90031 22.86 5.88031 22.91 5.83031L22.92 5.84031ZM18.53 12.3503H17.44C17.36 12.3503 17.29 12.4303 17.29 12.5203C17.29 12.6103 17.36 12.6903 17.44 12.6903H18.53C18.61 12.6903 18.68 12.6103 18.68 12.5203C18.68 12.4303 18.61 12.3503 18.53 12.3503ZM17.99 18.7103C17.72 18.7103 17.5 18.9303 17.5 19.2003C17.5 19.4703 17.72 19.6903 17.99 19.6903C18.26 19.6903 18.48 19.4703 18.48 19.2003C18.48 18.9303 18.26 18.7103 17.99 18.7103ZM20.08 11.2203H15.89C15.42 11.2203 15.03 11.6003 15.03 12.0803V17.1603C15.03 17.1603 15.02 17.1603 15.01 17.1603H2.24004C1.94004 17.1603 1.70004 16.9203 1.70004 16.6203V7.49031C1.70004 7.19031 1.94004 6.95031 2.24004 6.95031H12.37C12.62 6.95031 12.83 6.75031 12.83 6.49031C12.83 6.23031 12.63 6.03031 12.37 6.03031H2.24004C1.44004 6.03031 0.790039 6.68031 0.790039 7.48031V16.6103C0.790039 17.4103 1.44004 18.0603 2.24004 18.0603H8.57004V19.5303H5.51004C5.26004 19.5303 5.05004 19.7303 5.05004 19.9903C5.05004 20.2503 5.25004 20.4503 5.51004 20.4503H15.22C15.22 20.4503 15.3 20.4403 15.34 20.4303C15.49 20.5603 15.68 20.6403 15.89 20.6403H20.08C20.55 20.6403 20.94 20.2603 20.94 19.7803V12.0803C20.94 11.6103 20.56 11.2203 20.08 11.2203ZM12.2 19.5403H9.49004V18.0703H12.2V19.5403ZM13.11 18.0703H15.02C15.02 18.0703 15.03 18.0703 15.04 18.0703V19.5403H13.11V18.0703ZM20.24 19.7803C20.24 19.8703 20.17 19.9403 20.08 19.9403H15.89C15.8 19.9403 15.73 19.8703 15.73 19.7803V12.0803C15.73 11.9903 15.8 11.9203 15.89 11.9203H20.08C20.17 11.9203 20.24 11.9903 20.24 12.0803V19.7803Z'
                fill={props.fill1 ? props.fill1 : theme.palette.primary.heather}
                stroke={props.stroke1 ? props.stroke1 : theme.palette.primary.backgroundColor2}
                strokeOpacity={props.stroke1opacity ? props.stroke1opacity : '1'}
                fillOpacity={props.fill1opacity ? props.fill1opacity : '1'}
                strokeWidth={props.stroke1width ? props.stroke1width : '1'}
            />
        </SvgIcon>
    );
}

/**
 * @name HomeIcon - Home icon
 * @param {String} stroke1 - color for icon outline - default "white"
 * @param {String} fill1 - color to fill icon/icon background color -default "transparent"
 * @param {String} stroke1opacity - to change border opacity of icon - default "1"
 * @param {Boolean} fill1opacity - to change background opacity  of icon- default "0.6"
 * @param {Boolean} stroke1width - to change border width of icon - default "1.75"
 * @returns {<HomeIcon>} - returns HomeIcon as a jsx component
 */

function HomeIcon(props) {
    return (
        <SvgIcon {...props}>
            <path
                d='M10.8419 2.48073C9.4352 3.61969 0.74499 11.0177 0.630371 11.164C0.463652 11.373 0.453232 11.8641 0.619951 12.1567C0.932548 12.7523 1.50564 12.8045 2.1621 12.3029C2.41218 12.1253 2.69351 11.9059 2.79771 11.8223C2.98527 11.6864 2.99569 11.8014 2.99569 15.6049C2.99569 19.3039 3.00611 19.5651 3.20409 20.1085C3.46459 20.7981 4.02726 21.4042 4.7254 21.749L5.23597 21.9998H11.7484H18.2609L18.7819 21.7176C19.4487 21.3624 19.9072 20.8817 20.2094 20.2234C20.4386 19.7114 20.449 19.5965 20.5011 15.7094L20.5532 11.7282L21.1576 12.188C21.8974 12.7523 22.2621 12.7836 22.6997 12.3447C23.0123 12.0208 23.0853 11.6446 22.8977 11.2894C22.7935 11.1013 12.8529 2.56433 12.2798 2.17771C11.8318 1.87468 11.4983 1.94783 10.8419 2.48073ZM15.1974 7.12016L18.6256 10.0564V14.5495C18.6256 19.3248 18.6151 19.4606 18.1046 19.9099C17.9066 20.0876 17.6982 20.1294 16.6875 20.1503L15.4996 20.1921V17.0364C15.4996 13.5464 15.4787 13.3897 14.8327 12.9299C14.5201 12.7105 14.4159 12.7 11.8005 12.6687C9.23722 12.6478 9.0705 12.6582 8.74748 12.8567C8.55993 12.9717 8.32027 13.212 8.20565 13.4001C8.00767 13.724 7.99725 13.933 7.99725 16.9528V20.1712H6.95526C6.28838 20.1712 5.77781 20.1189 5.54857 20.0249C4.87128 19.7323 4.87128 19.7636 4.8817 14.6122V9.98323L8.28901 7.08881C10.1646 5.49009 11.7067 4.18395 11.7276 4.18395C11.7484 4.18395 13.301 5.51099 15.1974 7.12016ZM13.624 17.3499V20.1712H11.7484H9.87283V17.3499V14.5286H11.7484H13.624V17.3499Z'
                fill={props.fill1 ? props.fill1 : 'white'}
                stroke={props.stroke1 ? props.stroke1 : 'transparent'}
                strokeOpacity={props.stroke1opacity ? props.stroke1opacity : '1'}
                fillOpacity={props.fill1opacity ? props.fill1opacity : '0.6'}
                strokeWidth={props.stroke1width ? props.stroke1width : '1.75'}
            />
        </SvgIcon>
    );
}

/**
 * @name HomesIcon - Homes icon
 * @param {String} stroke1 - color for icon outline - default "transparent"
 * @param {String} fill1 - color to fill icon/icon background color - default "#892BA0"
 * @param {String} stroke1opacity - to change border opacity of icon - default "1"
 * @param {Boolean} fill1opacity - to change background opacity  of icon- default "1"
 * @param {Boolean} stroke1width - to change border width of icon - default "1.75"
 * @returns {<HomesIcon>} - returns HomesIcon as a jsx component
 */

function HomesIcon(props) {
    return (
        <SvgIcon {...props}>
            <path
                d='M19.0391 20.8405H14.1591C13.7691 20.8405 13.4491 20.5205 13.4491 20.1305V13.8905H10.4091V20.1305C10.4091 20.5205 10.0891 20.8405 9.69912 20.8405H4.97912C4.58912 20.8405 4.26912 20.5205 4.26912 20.1305V9.74047L5.68912 8.72047V8.92047V19.4205H8.98912V13.1805C8.98912 12.7905 9.30912 12.4705 9.69912 12.4705H14.1591C14.5491 12.4705 14.8691 12.7905 14.8691 13.1805V19.4205H18.3291V8.92047C18.3291 8.10047 18.6491 8.21047 19.0391 8.21047C19.4291 8.21047 19.7491 8.53047 19.7491 8.92047V20.1305C19.7491 20.5205 19.4291 20.8405 19.0391 20.8405ZM22.9491 11.3505C23.1791 11.0305 23.1091 10.5905 22.7991 10.3605L12.4291 2.74047C12.1791 2.56047 11.8491 2.56047 11.5991 2.74047L1.04912 10.3005C0.729117 10.5305 0.659117 10.9705 0.889117 11.2905C1.11912 11.6105 1.55912 11.6805 1.87912 11.4505L12.0091 4.18047L21.9591 11.5005C22.0891 11.5905 22.2291 11.6405 22.3791 11.6405C22.5991 11.6405 22.8091 11.5405 22.9491 11.3505ZM19.7491 9.87047V3.70047C19.7491 3.31047 19.4291 2.99047 19.0391 2.99047C18.6491 2.99047 18.3291 3.31047 18.3291 3.70047V8.83047L19.7491 9.87047Z"'
                fill={props.fill1 ? props.fill1 : theme.palette.primary.heather}
                stroke={props.stroke1 ? props.stroke1 : theme.palette.primary.backgroundColor2}
                strokeOpacity={props.stroke1opacity ? props.stroke1opacity : '1'}
                fillOpacity={props.fill1opacity ? props.fill1opacity : '1'}
                strokeWidth={props.stroke1width ? props.stroke1width : '1'}
            />
        </SvgIcon>
    );
}

/**
 * @name OffersIcon - Offers icon
 * @param {String} stroke1 - color for icon outline - default "transparent"
 * @param {String} fill1 - color to fill icon/icon background color -default "#892BA0"
 * @param {String} stroke1opacity - to change border opacity of icon - default "1"
 * @param {Boolean} fill1opacity - to change background opacity  of icon- default "1"
 * @param {Boolean} stroke1width - to change border width of icon - default "1.75"
 * @param {String} stroke2 - color for icon outline - default "#892BA0"
 * @param {String} fill2 - color to fill icon/icon background color - "transparent"
 * @param {String} stroke2opacity - to change border opacity of icon - default "1"
 * @param {Boolean} fill2opacity - to change background opacity  of icon- default "1"
 * @param {Boolean} stroke2width - to change border width of icon - default "1.75"
 * @param {String} stroke3 - color for icon outline - default "white"
 * @param {String} fill3 - color to fill icon/icon background color - "transparent"
 * @param {String} stroke3opacity - to change border opacity of icon - default "1"
 * @param {Boolean} fill3opacity - to change background opacity  of icon- default "1"
 * @param {Boolean} stroke3width - to change border width of icon - default "1.75"
 * @returns {<OffersIcon>} - returns OffersIcon as a jsx component
 */

function OffersIcon(props) {
    return (
        <SvgIcon {...props}>
            <path
                d='M21.4496 11.2403H2.60965C1.65965 11.2403 0.889648 10.4703 0.889648 9.52031V6.76031C0.889648 5.81031 1.65965 5.04031 2.60965 5.04031H21.4396C22.3897 5.04031 23.1596 5.81031 23.1596 6.76031V9.52031C23.1596 10.4703 22.3897 11.2403 21.4396 11.2403H21.4496ZM2.60965 6.46031C2.43965 6.46031 2.30965 6.59031 2.30965 6.76031V9.52031C2.30965 9.69031 2.44965 9.82031 2.60965 9.82031H21.4396C21.6096 9.82031 21.7396 9.69031 21.7396 9.52031V6.76031C21.7396 6.59031 21.5996 6.46031 21.4396 6.46031H2.60965ZM18.9096 23.6403H5.14965C4.03965 23.6403 3.13965 22.7403 3.13965 21.6303V10.5303C3.13965 10.1403 3.45965 9.82031 3.84965 9.82031H20.2096C20.5996 9.82031 20.9196 10.1403 20.9196 10.5303V21.6303C20.9196 22.7403 20.0196 23.6403 18.9096 23.6403ZM4.55965 11.2403V21.6403C4.55965 21.9703 4.82965 22.2303 5.14965 22.2303H18.9096C19.2396 22.2303 19.4996 21.9703 19.4996 21.6403V11.2403H4.55965ZM12.7396 6.46031H11.3196V22.2203H12.7396V6.46031ZM9.70965 6.30031C8.05965 6.30031 6.71965 4.96031 6.71965 3.31031C6.71965 1.66031 8.05965 0.320312 9.70965 0.320312C11.3596 0.320312 12.6996 1.66031 12.6996 3.31031C12.6996 4.96031 11.3596 6.30031 9.70965 6.30031ZM9.70965 1.73031C8.83965 1.73031 8.12965 2.44031 8.12965 3.31031C8.12965 4.18031 8.83965 4.89031 9.70965 4.89031C10.5796 4.89031 11.2896 4.18031 11.2896 3.31031C11.2896 2.44031 10.5796 1.73031 9.70965 1.73031ZM14.3496 6.30031C12.6996 6.30031 11.3596 4.96031 11.3596 3.31031C11.3596 1.66031 12.6996 0.320312 14.3496 0.320312C15.9996 0.320312 17.3396 1.66031 17.3396 3.31031C17.3396 4.96031 15.9996 6.30031 14.3496 6.30031ZM14.3496 1.73031C13.4796 1.73031 12.7696 2.44031 12.7696 3.31031C12.7696 4.18031 13.4796 4.89031 14.3496 4.89031C15.2196 4.89031 15.9296 4.18031 15.9296 3.31031C15.9296 2.44031 15.2196 1.73031 14.3496 1.73031Z'
                fill={props.fill1 ? props.fill1 : theme.palette.primary.heather}
            />
        </SvgIcon>
    );
}

/**
 * @name HelpIcon - help icon
 * @param {String} stroke1 - color for icon outline - default "#892BA0"
 * @param {String} fill1 - color to fill icon/icon background color -default "#892BA0"
 * @param {String} stroke1opacity - to change border opacity of icon - default "1"
 * @param {Boolean} fill1opacity - to change background opacity  of icon- default "1"
 * @param {Boolean} stroke1width - to change border width of icon - default "1.75"
 * @param {String} stroke2 - color for icon outline - default "white"
 * @param {String} fill2 - color to fill icon/icon background color -default "transparent"
 * @param {String} stroke2opacity - to change border opacity of icon - default "1"
 * @param {Boolean} fill2opacity - to change background opacity  of icon- default "1"
 * @param {Boolean} stroke2width - to change border width of icon - default "1.75"
 * @returns {<HelpIcon>} - returns HelpIcon as a jsx component
 */
function HelpIcon(props) {
    return (
        <SvgIcon {...props}>
            {/* <path
                d='M11.9993 16.8004V16.8426M9.60039 9.04572C9.60039 7.6952 10.6749 6.60039 12.0004 6.60039C13.3259 6.60039 14.4004 7.6952 14.4004 9.04572C14.4004 10.3962 13.3259 11.491 12.0004 11.491C12.0004 11.491 11.9993 12.2209 11.9993 13.1213M21.6004 12.0004C21.6004 17.3023 17.3023 21.6004 12.0004 21.6004C6.69846 21.6004 2.40039 17.3023 2.40039 12.0004C2.40039 6.69846 6.69846 2.40039 12.0004 2.40039C17.3023 2.40039 21.6004 6.69846 21.6004 12.0004Z'
                fill={props.fill1 ? props.fill1 : theme.palette.primary.sunset}
                stroke={props.stroke1 ? props.stroke1 : theme.palette.primary.sunset}
                strokeOpacity={props.stroke1opacity ? props.stroke1opacity : '1'}
                fillOpacity={props.fill1opacity ? props.fill1opacity : '1'}
                strokeWidth={props.stroke1width ? props.stroke1width : '1.75'}
                stroke-linecap='round'
                stroke-linejoin='round'
            />
            <path
                d='M11.9986 16.7999V16.842M9.59961 9.04518C9.59961 7.69466 10.6741 6.59985 11.9996 6.59985C13.3251 6.59985 14.3996 7.69466 14.3996 9.04518C14.3996 10.3957 13.3251 11.4905 11.9996 11.4905C11.9996 11.4905 11.9986 12.2204 11.9986 13.1207'
                stroke={props.stroke2 ? props.stroke2 : 'white'}
                fill={props.fill2 ? props.fill2 : 'transparent'}
                strokeOpacity={props.stroke2Opacity ? props.stroke2Opacity : '1'}
                fillOpacity={props.fill2Opacity ? props.fill2Opacity : '1'}
                strokeWidth={props.stroke2Width ? props.stroke2Width : '1.75'}
                stroke-linecap='round'
                stroke-linejoin='round'
            /> */}

            <g clip-path='url(#clip0_1550_7557)'>
                <path
                    d='M12.0002 23.7602C5.52023 23.7602 0.240234 18.4802 0.240234 12.0002C0.240234 5.52023 5.52023 0.240234 12.0002 0.240234C18.4802 0.240234 23.7602 5.51023 23.7602 12.0002C23.7602 18.4902 18.4902 23.7602 12.0002 23.7602ZM12.0002 1.66023C6.30023 1.66023 1.66023 6.30023 1.66023 12.0002C1.66023 17.7002 6.30023 22.3402 12.0002 22.3402C17.7002 22.3402 22.3402 17.7002 22.3402 12.0002C22.3402 6.30023 17.7002 1.66023 12.0002 1.66023ZM10.7202 14.6102L10.6802 14.1102C10.5602 13.0602 10.9102 11.9202 11.8802 10.7602C12.7502 9.73024 13.2402 8.98023 13.2402 8.11023C13.2402 7.12023 12.6202 6.46023 11.4002 6.44023C10.7002 6.44023 9.93023 6.67023 9.44023 7.04023L8.98023 5.82023C9.62023 5.36023 10.7202 5.05023 11.7502 5.05023C13.9802 5.05023 14.9802 6.42023 14.9802 7.90023C14.9802 9.22023 14.2402 10.1702 13.3102 11.2702C12.4602 12.2802 12.1502 13.1302 12.2102 14.1202L12.2302 14.6202H10.7202V14.6102ZM10.2902 17.3202C10.2902 16.6002 10.7702 16.1002 11.4502 16.1002C12.1302 16.1002 12.5902 16.6002 12.5902 17.3202C12.5902 18.0002 12.1402 18.5202 11.4302 18.5202C10.7502 18.5202 10.2902 18.0002 10.2902 17.3202Z'
                    fill={props.fill1 ? props.fill1 : theme.palette.primary.heather}
                    stroke={props.stroke1 ? props.stroke1 : theme.palette.primary.heather}
                    strokeOpacity={props.stroke1opacity ? props.stroke1opacity : '1'}
                    fillOpacity={props.fill1opacity ? props.fill1opacity : '1'}
                    strokeWidth={props.stroke1width ? props.stroke1width : '1'}
                    stroke-linecap='round'
                    stroke-linejoin='round'
                />
            </g>
            <defs>
                <clipPath id='clip0_1550_7557'>
                    <rect width='24' height='24' fill={theme.palette.primary.white} />
                </clipPath>
            </defs>
        </SvgIcon>
    );
}

/**
 * @name DownloadIcon - Download icon
 * @param {String} stroke1 - color for icon outline - default "transparent"
 * @param {String} fill1 - color to fill icon/icon background color - default "#D111C9"
 * @param {String} stroke1opacity - to change border opacity of icon - default "1"
 * @param {Boolean} fill1opacity - to change background opacity  of icon- default "1"
 * @param {Boolean} stroke1width - to change border width of icon - default "1.75"
 * @returns {<DownloadIcon>} - returns DownloadIcon as a jsx component
 */

function DownloadIcon(props) {
    return (
        <SvgIcon {...props}>
            <path
                d='M4.7526 17.6693C4.29427 17.6693 3.90205 17.5062 3.57594 17.1801C3.24927 16.8534 3.08594 16.4609 3.08594 16.0026V13.5026H4.7526V16.0026H14.7526V13.5026H16.4193V16.0026C16.4193 16.4609 16.2562 16.8534 15.9301 17.1801C15.6034 17.5062 15.2109 17.6693 14.7526 17.6693H4.7526ZM9.7526 14.3359L5.58594 10.1693L6.7526 8.96094L8.91927 11.1276V4.33594H10.5859V11.1276L12.7526 8.96094L13.9193 10.1693L9.7526 14.3359Z'
                fill={props.fill1 ? props.fill1 : '#D111C9'}
                stroke={props.stroke1 ? props.stroke1 : 'transparent'}
                strokeOpacity={props.stroke1opacity ? props.stroke1opacity : '1'}
                fillOpacity={props.fill1opacity ? props.fill1opacity : '1'}
                strokeWidth={props.stroke1width ? props.stroke1width : '1.75'}
            />
        </SvgIcon>
    );
}

/**
 * @name PaymentCardIcon - payment card/credit card icon
 * @param {String} stroke1 - color for icon outline - default #470A68
 * @param {String} fill1 - color to fill icon/icon background color - default transparent
 * @param {String} stroke1opacity - to change border opacity of icon - default "1"
 * @param {Boolean} fill1opacity - to change background opacity  of icon- default "1"
 * @param {Boolean} stroke1width - to change border width of icon - default "1.5"
 * @returns {<PaymentCardIcon>} - returns PaymentCardIcon as a jsx component
 */
function PaymentCardIcon(props) {
    return (
        <SvgIcon {...props}>
            <path
                d='M3.5 11V15.8002C3.5 16.9203 3.5 17.4801 3.71799 17.9079C3.90973 18.2842 4.21547 18.5905 4.5918 18.7822C5.0192 19 5.57899 19 6.69691 19H18.3031C19.421 19 19.98 19 20.4074 18.7822C20.7837 18.5905 21.0905 18.2842 21.2822 17.9079C21.5 17.4805 21.5 16.9215 21.5 15.8036V11M3.5 11V9M3.5 11H21.5M3.5 9V8.2002C3.5 7.08009 3.5 6.51962 3.71799 6.0918C3.90973 5.71547 4.21547 5.40973 4.5918 5.21799C5.01962 5 5.58009 5 6.7002 5H18.3002C19.4203 5 19.9796 5 20.4074 5.21799C20.7837 5.40973 21.0905 5.71547 21.2822 6.0918C21.5 6.5192 21.5 7.07899 21.5 8.19691V9M3.5 9H21.5M7.5 15H11.5M21.5 11V9'
                stroke={props.stroke1 ? props.stroke1 : '#470A68'}
                fill={props.fill1 ? props.fill1 : 'transparent'}
                strokeOpacity={props.stroke1opacity ? props.stroke1opacity : '1'}
                fillOpacity={props.fill1opacity ? props.fill1opacity : '1'}
                strokeWidth={props.stroke1width ? props.stroke1width : '1.5'}
                stroke-linecap='round'
                stroke-linejoin='round'
            />
        </SvgIcon>
    );
}

/**
 * @name UsageIcon - usage icon
 * @param {String} stroke1 - color for icon outline - default #470A68
 * @param {String} fill1 - color to fill icon/icon background color - default transparent
 * @param {String} stroke1opacity - to change border opacity of icon - default "1"
 * @param {Boolean} fill1opacity - to change background opacity  of icon- default "1"
 * @param {Boolean} stroke1width - to change border width of icon - default "1.5"
 * @returns {<UsageIcon>} - returns UsageIcon as a jsx component
 */
function UsageIcon(props) {
    return (
        <SvgIcon {...props}>
            <path
                d='M9.5 11V20M9.5 11H5.09961C4.53956 11 4.25981 11 4.0459 11.109C3.85774 11.2049 3.70487 11.3577 3.60899 11.5459C3.5 11.7598 3.5 12.04 3.5 12.6001V20H9.5M9.5 11V5.6001C9.5 5.04004 9.5 4.75981 9.60899 4.5459C9.70487 4.35774 9.85774 4.20487 10.0459 4.10899C10.2598 4 10.5396 4 11.0996 4H13.8996C14.4597 4 14.7403 4 14.9542 4.10899C15.1423 4.20487 15.2948 4.35774 15.3906 4.5459C15.4996 4.75981 15.5 5.04005 15.5 5.6001V8M9.5 20H15.5M15.5 20L21.5 20.0001V9.6001C21.5 9.04005 21.4996 8.75981 21.3906 8.5459C21.2948 8.35774 21.1429 8.20487 20.9548 8.10899C20.7409 8 20.4601 8 19.9 8H15.5M15.5 20V8'
                stroke={props.stroke1 ? props.stroke1 : '#470A68'}
                fill={props.fill1 ? props.fill1 : 'transparent'}
                strokeOpacity={props.stroke1opacity ? props.stroke1opacity : '1'}
                fillOpacity={props.fill1opacity ? props.fill1opacity : '1'}
                strokeWidth={props.stroke1width ? props.stroke1width : '1.5'}
                stroke-linecap='round'
                stroke-linejoin='round'
            />
        </SvgIcon>
    );
}

/**
 * @name PlusIcon - add in a circle icon
 * @param {String} fill - color to fill icon/icon background color - default #892BA0
 * @returns {<PlusIcon>} - returns PlusIcon as a jsx component
 */
function PlusIcon(props) {
    return (
        <SvgIcon {...props}>
            <path
                d='M11.5 5.00046H9.5V9.00046H5.5V11.0005H9.5V15.0005H11.5V11.0005H15.5V9.00046H11.5V5.00046ZM10.5 0.000457764C4.99 0.000457764 0.5 4.49046 0.5 10.0005C0.5 15.5105 4.99 20.0005 10.5 20.0005C16.01 20.0005 20.5 15.5105 20.5 10.0005C20.5 4.49046 16.01 0.000457764 10.5 0.000457764ZM10.5 18.0005C6.09 18.0005 2.5 14.4105 2.5 10.0005C2.5 5.59046 6.09 2.00046 10.5 2.00046C14.91 2.00046 18.5 5.59046 18.5 10.0005C18.5 14.4105 14.91 18.0005 10.5 18.0005Z'
                fill={props.fill ? props.fill : theme.palette.primary.sunset}
            />
        </SvgIcon>
    );
}
/**
 * @name BackArrowIcon - add in a circle icon
 * @param {String} fill - color to fill icon/icon background color - default #892BA0
 * @returns {<PlusIcon>} - returns PlusIcon as a jsx component
 */

function ArrowBackIcon(props) {
    return (
        <SvgIcon {...props}>
            <path
                d='M16.9219 18.5305L17.2755 18.1769L16.9219 17.8234L10.0709 10.9724L16.9219 4.12136L17.2755 3.76781L16.9219 3.41425L14.9836 1.47597L14.6301 1.12241L14.2765 1.47597L5.13366 10.6188L4.78011 10.9724L5.13366 11.3259L14.2765 20.4688L14.6301 20.8223L14.9836 20.4688L16.9219 18.5305Z'
                fill={props.fill ? props.fill : theme.palette.primary.sunset}
            />
        </SvgIcon>
    );
}

/**
 * @name VISAIcon - VISA Icon
 * @param {String} fill - color to fill icon/icon background color
 * @returns {<VISAIcon>} - returns VISAIcon as a jsx component
 */
function VISAIcon(props) {
    return (
        <SvgIcon
            {...props}
            style={{ position: 'relative', top: '0.3rem', width: '2.3em', marginLeft: '-1rem' }}
        >
            <svg
                width='31'
                height='10'
                viewBox='0 0 31 10'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <g clipPath='url(#clip0_143_30859)'>
                    <path
                        d='M15.9515 3.18409C15.9339 4.57149 17.1879 5.34577 18.1326 5.80608C19.1032 6.27843 19.4292 6.58129 19.4255 7.00362C19.4181 7.65009 18.6512 7.93535 17.9335 7.94646C16.6813 7.96591 15.9533 7.60841 15.3745 7.33797L14.9234 9.44871C15.5041 9.71638 16.5794 9.94977 17.6945 9.95996C20.3119 9.95996 22.0244 8.66795 22.0336 6.66464C22.0438 4.1223 18.517 3.98152 18.541 2.84511C18.5494 2.50057 18.8782 2.13288 19.5987 2.03934C19.9553 1.9921 20.9398 1.95598 22.0559 2.47001L22.4939 0.427801C21.8938 0.209224 21.1223 -9.05991e-05 20.1618 -9.05991e-05C17.6982 -9.05991e-05 15.9654 1.30952 15.9515 3.18409ZM26.7034 0.175881C26.2255 0.175881 25.8226 0.454659 25.6429 0.882551L21.904 9.80992H24.5195L25.04 8.37158H28.2362L28.5381 9.80992H30.8434L28.8317 0.175881H26.7034ZM27.0692 2.77842L27.8241 6.39605H25.7568L27.0692 2.77842ZM12.7802 0.175881L10.7186 9.80992H13.2109L15.2716 0.175881H12.7802ZM9.09315 0.175881L6.49895 6.73318L5.44959 1.15762C5.32641 0.535236 4.84017 0.175881 4.30022 0.175881H0.059275L0 0.455585C0.870602 0.644525 1.85975 0.949236 2.45899 1.27525C2.82575 1.47437 2.93041 1.64849 3.05081 2.12177L5.03837 9.80992H7.67241L11.7105 0.175881H9.09315Z'
                        fill='url(#paint0_linear_143_30859)'
                    />
                </g>
                <defs>
                    <linearGradient
                        id='paint0_linear_143_30859'
                        x1='1418'
                        y1='29.9416'
                        x2='1446.83'
                        y2='-992.972'
                        gradientUnits='userSpaceOnUse'
                    >
                        <stop stopColor='#222357' />
                        <stop offset='1' stopColor='#254AA5' />
                    </linearGradient>
                    <clipPath id='clip0_143_30859'>
                        <rect width='30.8434' height='10' fill='white' />
                    </clipPath>
                </defs>
            </svg>
        </SvgIcon>
    );
}

/**
 * @name MasterCardIcon - MasterCardIcon Icon
 * @param {String} fill - color to fill icon/icon background color
 * @returns {<MasterCardIcon>} - returns MasterCardIcon as a jsx component
 */
function MasterCardIcon(props) {
    return (
        <SvgIcon {...props} style={{ position: 'relative', top: '0.3rem' }}>
            <svg
                width='20'
                height='12'
                viewBox='0 0 20 12'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <path d='M12.3184 1.28345H7.06787V10.7165H12.3184V1.28345Z' fill='#FF5A00' />
                <path
                    d='M7.41747 5.99999C7.41747 4.08349 8.31844 2.38251 9.70095 1.28348C8.68349 0.483494 7.39998 0 5.99998 0C2.68348 0 0 2.68349 0 5.99999C0 9.31649 2.68348 12 5.99998 12C7.39998 12 8.68349 11.5165 9.70095 10.7165C8.3165 9.63299 7.41747 7.91648 7.41747 5.99999Z'
                    fill='#EB001B'
                />
                <path
                    d='M19.4021 5.99999C19.4021 9.31649 16.7186 12 13.4021 12C12.0021 12 10.7186 11.5165 9.70117 10.7165C11.1012 9.61553 11.9847 7.91648 11.9847 5.99999C11.9847 4.08349 11.0837 2.38251 9.70117 1.28348C10.7167 0.483494 12.0002 0 13.4002 0C16.7186 0 19.4021 2.70097 19.4021 5.99999Z'
                    fill='#F79E1B'
                />
            </svg>
        </SvgIcon>
    );
}

export {
    BillsIcon,
    ServicesIcon,
    HomeIcon,
    OffersIcon,
    HelpIcon,
    ArrowBackIcon,
    HomesIcon,
    DownloadIcon,
    PaymentCardIcon,
    UsageIcon,
    PlusIcon,
    VISAIcon,
    MasterCardIcon,
};
